/**
 * Behind The Collection — collection-page blurb.
 *
 * Progressive enhancement for the "Learn more" disclosure. The expanded content
 * (including its image) lives inside an inert <template>, so the browser does
 * NOT request that media on initial page load. It is cloned into the DOM only
 * when the shopper first clicks "Learn more", then the panel animates open via a
 * CSS grid-rows transition. Keeps the collection page fast by default.
 *
 * Interaction model: "Learn more" (top) only opens; "Show less" (rendered at the
 * end of the revealed content) only collapses and returns scroll/focus to the
 * heading — where a shopper who has finished reading actually is.
 */
if (!customElements.get('collection-story')) {
  customElements.define(
    'collection-story',
    class CollectionStory extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.collection-story__toggle');
        this.reveal = this.querySelector('.collection-story__reveal');
        this.panel = this.querySelector('.collection-story__more');
        this.template = this.querySelector('template.collection-story__template');
        this.heading = this.querySelector('.collection-story__heading');

        if (!this.toggle || !this.reveal || !this.panel || !this.template) return;

        this.loaded = false;

        // Reveal the control now that JS is available. Without JS, shoppers still
        // get the "View full story" link, so we never show a dead button.
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => this.expand());
      }

      expand() {
        if (!this.loaded) {
          this.panel.appendChild(this.template.content.cloneNode(true));
          this.loaded = true;

          const collapseBtn = this.panel.querySelector('.collection-story__collapse');
          if (collapseBtn) {
            collapseBtn.addEventListener('click', () => this.collapse());
          }
        }

        this.reveal.setAttribute('data-expanded', '');
        this.toggle.setAttribute('aria-expanded', 'true');
        this.setAttribute('data-open', '');
      }

      collapse() {
        this.reveal.removeAttribute('data-expanded');
        this.toggle.setAttribute('aria-expanded', 'false');
        this.removeAttribute('data-open');

        // Bring the reader back to the top of the block and restore focus to the
        // control that reappears, so the page doesn't jump to mid-content.
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const anchor = this.heading || this;
        anchor.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
        this.toggle.focus({ preventScroll: true });
      }
    }
  );
}
